import { render, staticRenderFns } from "./asyncLoadComp.vue?vue&type=template&id=a3415970&"
import script from "./asyncLoadComp.vue?vue&type=script&lang=js&"
export * from "./asyncLoadComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports